
function convert_unit(unit) {

  if (unit < 1000)
      return Math.round(unit).toString() ;

  unit = Math.round (unit / 1000) ;
  if (unit < 1000)
      return unit + "K" ;

  unit = Math.round (unit / 1000) ;
  if (unit < 1000)
      return unit + "M" ;

  unit = Math.round (unit / 1000) ;
  return unit + "B" ;
}

function drawLine(ctx, startX, startY, endX, endY,color){
    ctx.save();
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.moveTo(startX,startY);
    ctx.lineTo(endX,endY);
    ctx.stroke();
    ctx.restore();
}


class LineGraph {
  constructor(options) {
    this.options = options;
    this.canvas = options.canvas;
    this.ctx = this.canvas.getContext("2d");
    this.colors = options.colors;
    this.titleOptions = options.titleOptions;
    this.maxValue = options.maxValue ;
    this.xScale = options.xScale ;
    this.ctx.reset();
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.beginPath();
  }

  drawLabel() {
    this.ctx.save();
    this.ctx.textBaseline = "bottom";
    this.ctx.textAlign = this.titleOptions.align;

    if (this.options.Xunit != '') 
      this.ctx.fillText(this.options.Xunit, 10, 10);   // center align

    let xPos = this.canvas.width / 2 ;
    this.ctx.font = `bold 12pt Arial`;
    this.ctx.fillStyle = "black" ;
    this.ctx.fillText(this.options.seriesName, xPos, 20);   // center align

    this.ctx.font = `normal 10pt Courier`;
    this.ctx.fillStyle = "black" ;

    xPos = 30 ;
    let inc = (this.canvas.width - this.options.padding) / this.xScale ;
    for (let i = this.options.unitstart ; i <= this.xScale ; i++) {
        let num = i.toString();
        if (num.length < 2) num = "0" + num ;
        this.ctx.fillText(num, xPos, this.canvas.height - 5);
        xPos += inc ;
    }
    this.ctx.restore();
  }

  // Xslot 0 - 19  
  drawLines(data, color) {
    var canvasActualHeight = this.canvas.height - this.options.padding * 2;
    let width = this.canvas.width - this.options.padding ;

    if (data.length < 1) return ;

    let PercentfromY = parseFloat(data[0][1]) ;
    let fromX = data[0][0] * width + this.options.padding ;
    var fromY = canvasActualHeight * (1 - PercentfromY / this.maxValue) + this.options.padding;

    for (let i = 1 ; i < data.length ;i++) {
       let toX = data[i][0] * width + this.options.padding ;
       let PercenttoY = parseFloat(data[i][1]) ;
       var toY   = canvasActualHeight * (1 - PercenttoY / this.maxValue) + this.options.padding;
       drawLine( this.ctx, fromX, fromY, toX, toY, color );
       fromX = toX ;
       fromY = toY ;
    }
  }
  
  drawGridLines() {
    var canvasActualHeight = this.canvas.height - this.options.padding * 2;

    var gridValue = 0;

    while (gridValue <= this.maxValue) {
      var gridY =
        canvasActualHeight * (1 - gridValue / this.maxValue) +
        this.options.padding;
      drawLine(
        this.ctx,
        0,
        gridY,
        this.canvas.width,
        gridY,
        this.options.gridColor
      );
      drawLine(
        this.ctx,
        30,
        this.options.padding/2,
        30,
        gridY + this.options.padding/2,
        this.options.gridColor
      );
      // Writing grid markers 
      this.ctx.save();
      this.ctx.fillStyle = "black" ;
      this.ctx.textBaseline = "bottom";
      this.ctx.font = "bold 10px Arial";

      let cnvunit = convert_unit(gridValue) ;
      let unit = cnvunit + this.options.unit ;
      this.ctx.fillText(unit, 0, gridY - 2);
      this.ctx.restore();
      gridValue +=  this.maxValue / this.options.gridScale ;
    }
  }

  drawLegend(legend) {
    let pIndex = 0;
    let ul = document.createElement("ul");
    legend.append(ul);
    for (let ctg of Object.keys(this.options.data)) {
      let li = document.createElement("li");
      li.style.listStyle = "none";
      li.style.borderLeft =
        "20px solid " + this.colors[pIndex % this.colors.length];
      li.style.padding = "5px";
      li.textContent = ctg;
      ul.append(li);
      pIndex++;
    }
  }

  draw() {
    this.drawGridLines();
    this.drawLabel();
  }
}

export default LineGraph ;
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
